// Route/page matching for tours, kept dependency-free so it can be tested alone.

export const pathInScope = (pathname, scope, exact = false) =>
  !!scope && (pathname === scope || (!exact && pathname.startsWith(`${scope}/`)));

/**
 * The tour for what's on screen.
 *
 * - `page` tours belong to a tab whose content is marked
 *   `data-tour-page="<page>"`. They cover tabs that switch without a URL
 *   change, and win over route tours because they are more specific. With
 *   several markers on screen (nested tabs) the last one in DOM order — the
 *   innermost — wins.
 * - route tours (`scope`) match the pathname; the longest scope wins, so
 *   /settings/emails picks the email tour over the settings tour.
 */
export const findTourFor = (tours, pathname, pages = []) => {
  for (let i = pages.length - 1; i >= 0; i -= 1) {
    const hit = tours.find((tour) => tour.page && tour.page === pages[i]);
    if (hit) return hit;
  }
  return tours
    .filter((tour) => !tour.page && pathInScope(pathname, tour.scope, tour.exact))
    .sort((a, b) => b.scope.length - a.scope.length)[0] || null;
};

export const findTourForPath = (tours, pathname) => findTourFor(tours, pathname, []);

/** data-tour-page values currently in the DOM, in document order. */
export const readPageMarkers = () => (typeof document === 'undefined' ? [] : [
  ...document.querySelectorAll('[data-tour-page]'),
].map((el) => el.getAttribute('data-tour-page')));
